import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import ViewAllRent from "./ViewAllRent";
import {
  change_Lang,
  EveryTimeTo_English,
} from "../../../actions/Helper_action";
import {
  Update_RentContract,
  View_Rent_Contract,
  View_All_Rent_Contract,
  Get_List_All_Rent_Contracts,
} from "../../../actions/Invoice_action";
export class View_AllRent extends Component {
  render() {
    const {
      rent_all_view_obj,
      lang,
      change_Lang,
      View_Rent_Contract,
      Update_RentContract,
      EveryTimeTo_English,
      index_all_rent,
      name_arb,
      name_en,
      name_krd,
      onClose,
    } = this.props;
    return (
      <Fragment>
        <ViewAllRent
          rent_all_view_obj={rent_all_view_obj}
          lang={lang}
          change_Lang={change_Lang}
          View_Rent_Contract={View_Rent_Contract}
          Update_RentContract={Update_RentContract}
          EveryTimeTo_English={EveryTimeTo_English}
          index_all_rent={index_all_rent}
          name_arb={name_arb}
          name_en={name_en}
          name_krd={name_krd}
          onClose={onClose}
          Get_List_All_Rent_Contracts={Get_List_All_Rent_Contracts}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    rent_all_view_obj: state.InvoiceReducer.rent_all_view_obj,
    all_rent_contracts: state.InvoiceReducer.all_rent_contracts,
    lang: state.HelperReducer.lang,
    index_all_rent: state.InvoiceReducer.index_all_rent,
    name_krd: state.HelperReducer.name_krd,
    name_arb: state.HelperReducer.name_arb,
    name_en: state.HelperReducer.name_en,
    Get_List_All_Rent_Contracts,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
    EveryTimeTo_English: (keys) => dispatch(EveryTimeTo_English(keys)),
    View_Rent_Contract: (id) => dispatch(View_Rent_Contract(id)),
    Update_RentContract: (id, data) => dispatch(Update_RentContract(id, data)),
    View_All_Rent_Contract: (id, index) =>
      dispatch(View_All_Rent_Contract(id, index)),
    Get_List_All_Rent_Contracts: () => dispatch(Get_List_All_Rent_Contracts()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(View_AllRent);
